import {
  Drawer,
  Typography,
  Button,
  Slider,
  Radio,
  TextField,
  MenuItem,
  FormControl,
  Select,
  Box,
  RadioGroup,
  FormControlLabel,
  InputLabel,
  Tab,
  Tabs,
  Tooltip,
  Divider,
 
} from "@mui/material";
import {
  ShapeEditorDrawer,
  StyledSubMenu,
  StyledSubMenuContainer,
  StyledSubMenuTitleContainer,
  drawerWidth,
} from "../../Utils/styledComps";
import ColorPicker from "react-best-gradient-color-picker";
import ColorWheel from "../Shared/ColorWheel"
import {
  changeOutlierColors,
  changeVennCircleColors,
  changeWhiskerBoxColors,
} from "../Tools/paintTools";
import { useEffect, useState } from "react";
import { IoShapes } from "react-icons/io5";
import { TbDimensions, TbScanPosition, TbSkewX } from "react-icons/tb";
import { BiColorFill } from "react-icons/bi";
import {
  ChevronLeft,
  ChevronRight,
  Close,
  ColorLensOutlined,
  Delete,
  Menu,
  GradientOutlined,
  Crop,
  CropSquare,
  CircleOutlined,
  ChangeHistory,
  StarBorder,
  CheckBoxOutlineBlank,
  Stop, // Square
  HexagonOutlined, // Fallback if specific icons aren't available
} from "@mui/icons-material";
import { gradientToCssString } from "../Tools/colorTools";
import { CgColorBucket } from "react-icons/cg";
import { BsPentagon, BsHexagon, BsOctagon, BsBoundingBoxCircles } from "react-icons/bs"; 
import { TbOvalVertical, TbDiamond, TbRectangle  } from "react-icons/tb";
function TabPanel(props) {
  const { children, subClass, value, index, type, ...other } = props;
  return (
    <StyledSubMenuContainer
      sx={{display: value !== index ? "none" : "block" }}
      role="tabpanel"
      // hidden={value !== index}
      id={`${type}-${index}`}
      aria-labelledby={`${subClass}-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "320px", maxHeight: "830px" }}>{children}</Box>
      )}
    </StyledSubMenuContainer>
  );
}
function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

function isChart(activeObj) {
  return activeObj?.length > 0
    ? activeObj?.[0]?.class === "chart" || activeObj?.[0]?.class === "plot"
    : true;
}
export const ShapeEditor = ({
  open,
  handleOpen,
  handleClose,
  containerDim,
  activeObj,
  canvas,
  handleDeleteObject,
  addCustomControls,
  handlePropertyChange,
  handleStartAngleChange,
  handleEndAngleChange,
  handleAngleTypeChange,
  handleStarCornersChange,
  handleSpokeRatioChange,
  handlePolygonDistortionChange,
  conversionRates,
  lineStyle,
  handleChangeLine,
  cornerRadius,
  handleChange,
  setFactoral,
  factoral,
  handlePositionChange,
  handleDatasetDataChange,
  handleLabelChange,
  handleDatasetLabelChange,
  handleColorChange,
  handleBorderColorChange,
  startAngle,
  endAngle,
  angleType,
  handlePolygonCornersChange,
  changeOpacityOfObj,
  opacityObj,
  setOpacityObj,
  handleEnterCrop,
  handleApplyCrop, 
  handleCancelCrop,
  handleCropShapeChange,
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const [activeColorTab, setActiveColorTab] = useState(0);
  const [colorTab, setColorTab] = useState("Fill");
  const [datasetLabels, setDatasetLabels] = useState({});
  const [selectedCropShape, setSelectedCropShape] = useState('rect');
  const [prevColor, setPrevColor] = useState({
    field:"",
    color:null
  });
  const marks = [
    { value: 0, label: '0%' },
    { value: 0.2, label: '20%' },
    { value: 0.4, label: '40%' },
    { value: 0.6, label: '60%' },
    { value: 0.8, label: '80%' },
    { value: 1, label: '100%' },
  ];

  // useEffect(() => {
  //   if (activeTab === 5 && activeObj?.length > 0) {
  //     const selectedObj = activeObj[0];
  //     // if (selectedObj.class !== 'cropOverlay') {
  //     //   handleEnterCrop();
  //     // }
  //   }
  // }, [activeObj, activeTab]);

  const [strokePrevColor,setStrokePrevColor] =useState(null)
  const [previousObjId, setPreviousObjId] = useState(null);

  // AUTO-RESET CROP STATE WHEN A DIFFERENT OBJECT IS SELECTED (not just activeObj change)
  useEffect(() => {
    if (activeTab === 5 && activeObj?.length > 0) {
      const currentObjId = activeObj[0].id || activeObj[0].name;
      if (previousObjId && previousObjId !== currentObjId) {
        // Different object selected while on crop tab - reset crop state
        handleCancelCrop();
      }
      setPreviousObjId(currentObjId);
    }
  }, [activeObj, activeTab, previousObjId]);

  const handleTabChange = (event, newValue) => {
    if (newValue === 5) {
      if (activeObj?.length > 0) {
        handleEnterCrop();
      }
    } else if (activeTab === 5) {
      // If leaving crop tab, cancel the operation
      handleCancelCrop();
      setSelectedCropShape('rect');
    }
    setActiveTab(newValue);
    if (newValue === 0) {
      //console.log("handleTabChange: newValue:  is 0:", newValue, open);

      if (open) {
        console.log(
          "handleTabChange: newValue:  is 0: is open:",
          newValue,
          open
        );
        handleClose();
        setSelectedCropShape('rect');
        setActiveTab(1);
      } else {
        console.log(
          "handleTabChange: newValue:  is 0: is not open:",
          newValue,
          open
        );

        handleOpen();
        if (activeObj?.length > 0) {
          setActiveTab(1);
        } else {
          setActiveTab(5);
        }
      }
    }
    //console.log("handleTabChange: newValue: final", newValue, open);
  };
  const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

  const tabs = [
    {
      icon: !open ? (
        <ChevronLeft color="error" />
      ) : (
        <ChevronRight sx={{ color: '#00FF00' }} />
      ),
      title: !open ? "Open Editor" : "Close Editor",
      disabled: false,
    },
    {
      icon: <IoShapes size={22} />,
      title: "Dimensions",
      disabled: activeObj?.length > 0 ? false : true,
    },
    {
      icon: <TbDimensions size={22} />,
      title: "Shape",
      disabled: isChart(activeObj),
    },
    {
      icon: <BiColorFill size={22} />,
      title: "Fill & Stroke",
      disabled: isChart(activeObj),
    },
    {
      icon: <TbScanPosition size={22} />,
      title: "Position",
      disabled: activeObj?.length > 0 ? false : true,
    },
    {
      icon: <Crop size={22} />, 
      title: "Crop Tool",
      disabled: activeObj?.length > 0 ? false : true,
    },
  ];
  function tab0() {
    return (
      <>
        <Typography align="center" variant="h6">
          Dimensions
        </Typography>
        {activeObj?.[0]?.chart?.type == "bar" &&
          activeObj?.[0]?.chart?.data.datasets.map((dataset, datasetIndex) => (
            <div key={datasetIndex}>
              <Typography>{dataset.label}</Typography>
              {dataset.backgroundColor.map((color, colorIndex) => (
                <div
                  key={colorIndex}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <Typography>Bar {colorIndex + 1}</Typography>
                  <TextField
                    label={`Value for Bar ${colorIndex + 1}`}
                    variant="outlined"
                    size="small"
                    type="number"
                    value={dataset.data[colorIndex]}
                    onChange={(e) =>
                      handleDatasetDataChange(
                        parseFloat(e.target.value),
                        colorIndex
                      )
                    } // Handle data value change
                    // style={{ marginTop: '10px', width: '100%' }}
                  />
                  {/* ColorPicker for selecting the bar color */}
                  <Typography>
                    Label Point {colorIndex + 1}: {color.label}
                  </Typography>
                  <TextField
                    label={`Label for Point ${colorIndex + 1}`}
                    variant="outlined"
                    size="small"
                    value={activeObj[0].chart.data.labels[colorIndex]}
                    onChange={(e) =>
                      handleLabelChange(e.target.value, colorIndex)
                    }
                  />
                  <ColorPicker
                    color={color}
                    value={color}
                    hideControls
                    hideGradientControls
                    hideInputs
                    hidePresets
                    onChange={(newColor) =>
                      handleColorChange(newColor, colorIndex)
                    }
                  />
                </div>
              ))}
            </div>
          ))}
        {(activeObj?.[0]?.chart?.type == "pie" ||
          activeObj?.[0]?.chart?.type == "doughnut" ||
          activeObj?.[0]?.chart?.type == "barVertical" ||
          activeObj?.[0]?.chart?.type == "barHorizontal") &&
          activeObj?.[0]?.chart?.data.datasets.map((dataset, datasetIndex) => (
            <div key={datasetIndex}>
              <Typography>{dataset.label}</Typography>
              {dataset.data.map((value, dataIndex) => (
                <div
                  key={dataIndex}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <Typography>
                    Label Point {dataIndex + 1}: {value.label}
                  </Typography>
                  <TextField
                    label={`Label for Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    value={activeObj[0]?.chart?.data?.labels?.[dataIndex]}
                    onChange={(e) =>
                      handleLabelChange(e.target.value, dataIndex)
                    }
                  />

                  <Typography>Data Point {dataIndex + 1}</Typography>

                  <TextField
                    label={`Value for Data Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    type="number"
                    value={value} // Bind to the current data point value
                    onChange={(e) =>
                      handleDatasetDataChange(
                        parseFloat(e.target.value),
                        dataIndex
                      )
                    } // Handle data value change
                  />

                  {dataset.backgroundColor &&
                    dataset.backgroundColor[dataIndex] && (
                      <ColorPicker
                        color={dataset.backgroundColor[dataIndex]}
                        value={dataset.backgroundColor[dataIndex]}
                        hideControls
                        hideGradientControls
                        hideInputs
                        hidePresets
                        onChange={(newColor) =>
                          handleColorChange(newColor, dataIndex)
                        } // Handle background color change
                      />
                    )}
                </div>
              ))}

              <div
                style={{
                  marginBottom: "10px",
                  display: "flex",
                  gap: 10,
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                }}
              >
                <Typography>Border Color</Typography>

                <ColorPicker
                  color={dataset.borderColor}
                  value={dataset.borderColor}
                  hideControls
                  hideGradientControls
                  hideInputs
                  hidePresets
                  onChange={(newColor) => handleBorderColorChange(newColor)} // Handle border color change
                />
              </div>
            </div>
          ))}
        {activeObj?.[0]?.chart?.type == "scatter" &&
          activeObj?.[0]?.chart?.data.datasets.map((dataset, datasetIndex) => (
            <div key={datasetIndex}>
              {/* <Typography>{dataset?.label}</Typography> */}
              {dataset.data.map((value, dataIndex) => (
                <div
                  key={dataIndex}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <Typography>
                    Label Point {dataIndex + 1}: {value.label}
                  </Typography>
                  <TextField
                    label={`Label for Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    value={dataset.label}
                    onChange={(e) =>
                      handleLabelChange(e.target.value, dataIndex)
                    }
                  />

                  <Typography>Data Point {dataIndex + 1}</Typography>

                  <TextField
                    label={`Value for Data Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    type="number"
                    value={dataset.data} // Bind to the current data point value
                    onChange={(e) =>
                      handleDatasetDataChange(
                        parseFloat(e.target.value),
                        dataIndex
                      )
                    } // Handle data value change
                  />

                  {dataset.backgroundColor &&
                    dataset.backgroundColor[dataIndex] && (
                      <ColorPicker
                        color={dataset.backgroundColor[dataIndex]}
                        value={dataset.backgroundColor[dataIndex]}
                        hideControls
                        hideGradientControls
                        hideInputs
                        hidePresets
                        onChange={(newColor) =>
                          handleColorChange(newColor, dataIndex)
                        } // Handle background color change
                      />
                    )}
                </div>
              ))}

              <div
                style={{
                  marginBottom: "10px",
                  display: "flex",
                  gap: 10,
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                }}
              >
                <Typography>Border Color</Typography>

                <ColorPicker
                  color={dataset.borderColor}
                  value={dataset.borderColor}
                  hideControls
                  hideGradientControls
                  hideInputs
                  hidePresets
                  onChange={(newColor) => handleBorderColorChange(newColor)} // Handle border color change
                />
              </div>
            </div>
          ))}
        {activeObj?.[0]?.chart?.type === "line" &&
          activeObj?.[0]?.chart?.data.datasets.map((dataset, datasetIndex) => (
            <div
              key={datasetIndex}
              style={{
                marginBottom: "10px",
                display: "flex",
                gap: 10,
                justifyContent: "center",
                flexDirection: "column",
                alignContent: "center",
              }}
            >
              <Typography>Dataset Point {datasetIndex + 1}</Typography>

              <TextField
                label={`Dataset for Point ${datasetIndex + 1}`}
                variant="outlined"
                size="small"
               value={datasetLabels[datasetIndex] || dataset.label || ""}
                onChange={(e) =>{
                  const newLabel = e.target.value;
                  setDatasetLabels((prevLabels) => ({
                    ...prevLabels,
                    [datasetIndex]: newLabel,
                  }));
                handleDatasetLabelChange(e.target.value, datasetIndex, "dateset")
                }}
              />

              {dataset?.data?.map((value, dataIndex) => (
                <div
                  key={dataIndex}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <Typography>Label Point {dataIndex + 1}</Typography>

                  <TextField
                    label={`Label for Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    value={activeObj[0]?.chart?.data?.labels?.[dataIndex] || ""}
                    onChange={(e) =>
                      handleLabelChange(e.target.value, dataIndex)
                    }
                  />

                  <Typography>Data Point {dataIndex + 1}</Typography>
                  <TextField
                    label={`Value for Data Point ${dataIndex + 1}`}
                    variant="outlined"
                    size="small"
                    type="number"
                    value={value} // Bind to the current data point value
                    onChange={(e) =>
                      handleDatasetDataChange(
                        parseFloat(e.target.value),
                        dataIndex
                      )
                    } // Handle data value change
                  />

                  {dataset.backgroundColor &&
                    dataset.backgroundColor[dataIndex] && (
                      <ColorPicker
                        color={dataset.backgroundColor[dataIndex]}
                        value={dataset.backgroundColor[dataIndex]}
                        hideControls
                        hideGradientControls
                        hideInputs
                        hidePresets
                        onChange={(newColor) =>
                          handleColorChange(newColor, dataIndex)
                        } // Handle background color change
                      />
                    )}
                </div>
              ))}

              <div
                style={{
                  marginBottom: "10px",
                  display: "flex",
                  gap: 10,
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                }}
              >
                <Typography>Border Color</Typography>
                <ColorPicker
                  color={dataset.borderColor}
                  value={dataset.borderColor}
                  hideControls
                  hideGradientControls
                  hideInputs
                  hidePresets
                  onChange={(newColor) => handleBorderColorChange(newColor)} // Handle border color change
                />
              </div>
            </div>
        ))}

        {activeObj?.[0].subClass === "venn"
          ? activeObj?.[0]?._objects
              ?.filter((obj) => obj.type === "path" && obj?.fill?.length > 0)
              .map((dataset, datasetIndex) => (
                <div key={dataset}>
                  <Typography>{dataset.label}</Typography>
                  <div style={{ marginBottom: "10px" }}>
                    <Typography>Venn Section {datasetIndex + 1}</Typography>
                    <ColorPicker
                      color={dataset.fill}
                      hideControls
                      hideGradientControls
                      hideInputs
                      hidePresets
                      value={dataset.fill}
                      onChange={(newColor) =>
                        changeVennCircleColors(dataset, newColor, canvas)
                      }
                    />
                  </div>
                </div>
              ))
          : activeObj?.[0]?._objects?.map((dataset, datasetIndex) => {
              if (dataset.type === "rect" && dataset?.fill?.length > 0) {
                return (
                  <div key={datasetIndex} style={{ marginBottom: "20px" }}>
                    <Typography>Box {datasetIndex + 1}</Typography>
                    <ColorPicker
                      color={dataset.fill}
                      value={dataset.fill}
                      hideControls
                      hideGradientControls
                      hideInputs
                      hidePresets
                      onChange={(newColor) =>
                        changeWhiskerBoxColors(dataset, newColor, canvas)
                      }
                    />
                  </div>
                );
              }

              if (dataset.type === "circle" && dataset?.fill?.length > 0) {
                return (
                  <div key={datasetIndex} style={{ marginBottom: "20px" }}>
                    <Typography>Outlier {datasetIndex + 1}</Typography>
                    <ColorPicker
                      hideControls
                      hideGradientControls
                      hideInputs
                      hidePresets
                      color={dataset.fill}
                      value={dataset.fill}
                      onChange={(newColor) =>
                        changeOutlierColors(dataset, newColor, canvas)
                      }
                    />
                  </div>
                );
              }

              return null;
            })}
        {activeObj?.[0].class == "circle" && (
          <>
            <TextField
              label="Radius"
              type="number"
              value={activeObj?.[0].radius}
              onChange={(e) =>
                handlePropertyChange("radius", parseFloat(e.target.value))
              }
              fullWidth
              margin="normal"
            />

            <TextField
              label="Start Angle"
              type="number"
              value={startAngle}
              onChange={handleStartAngleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="End Angle"
              type="number"
              value={endAngle}
              onChange={handleEndAngleChange}
              fullWidth
              margin="normal"
            />

            <FormControl fullWidth margin="normal">
              <InputLabel>Angle Type</InputLabel>
              <Select value={angleType} onChange={handleAngleTypeChange}>
                <MenuItem value="arc">Arc</MenuItem>
                <MenuItem value="chord">Chord</MenuItem>
              </Select>
            </FormControl>
          </>
        )}
        {activeObj?.[0]?.class === "star" ||
        activeObj?.[0]?.class === "polygon" ? (
          <>
            <TextField
              label="Corners"
              type="number"
              value={activeObj?.[0].corners}
              onChange={(e) =>
                activeObj?.[0]?.class === "star"
                  ? handleStarCornersChange(e.target.value)
                  : handlePolygonCornersChange(e.target.value)
              }
              fullWidth
              margin="normal"
              inputProps={{ min: 3 }} // Star must have at least 5 corners
            />
            {activeObj?.[0]?.class !== "polygon" && (
              <TextField
                inputMode="numeric"
                inputProps={{
                  step: "0.01",
                  min: "0",
                  max: "1",
                }}
                label="Spoke Ratio"
                type="number"
                value={activeObj?.[0]?.spokeRatio} // Default value, adjust as needed
                onChange={(e) =>
                  handleSpokeRatioChange(parseFloat(e.target.value))
                }
                fullWidth
                margin="normal"
              />
            )}
          </>
        ) : null}

        {activeObj?.[0]?.class !== "circle" &&
          activeObj?.[0]?.class !== "chart" &&
          activeObj?.[0]?.class !== "plot" &&
          activeObj?.[0]?.class !== "line" && (
            <>
              <TextField
                label="Distortion Factor"
                type="number"
                onChange={(e) => handlePolygonDistortionChange(e.target.value)}
                fullWidth
                margin="normal"
                inputProps={{
                  step: "0.01",
                  min: "0.1",
                  max: "10",
                }}
              />
            </>
          )}
        {activeObj?.[0].class !== "circle" &&
          activeObj?.[0].class !== "line" && (
            <>
              <TextField
                label="Width"
                type="number"
                value={
                  roundToTwoDecimals(
                  activeObj?.[0].width / conversionRates[activeObj?.[0].unit])
                }
                onChange={(e) =>
                  handlePropertyChange(
                    "width",
                    e.target.value ? parseFloat(e.target.value) : 0.1
                  )
                }
                fullWidth
                margin="normal"
              />
              <TextField
                label="Height"
                type="number"
                value={
                  roundToTwoDecimals(activeObj?.[0].height / conversionRates[activeObj?.[0].unit])
                }
                onChange={(e) =>
                  handlePropertyChange(
                    "height",
                    e.target.value ? parseFloat(e.target.value) : 0.1
                  )
                }
                fullWidth
                margin="normal"
              />
            </>
          )}
        {activeObj?.[0]?.class !== "chart" &&
          activeObj?.[0]?.class !== "plot" && (
            <TextField
              label="Stroke Width"
              type="number"
              value={
                activeObj?.[0]?.strokeWidth ?? ""
              }
              onChange={(e) =>
                handlePositionChange(
                  "strokeWidth",
                  e.target.value ? parseFloat(e.target.value) : 0.1
                )
              }
              fullWidth
              margin="normal"
            />
          )}
      </>
    );
  }

  function tab1() {
    return (
      <>
        <Typography align="center" variant="h6">
          Shape
        </Typography>
        {activeObj?.[0].class !== "circle" && (
          <div style={{ marginTop: "20px", padding: "20px" }}>
            <Box
              sx={{
                ml: "-10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography gutterBottom>Corner Radius: </Typography>
              {cornerRadius}
            </Box>
            <Slider
              value={
                activeObj?.[0].cornerRadius
                  ? activeObj?.[0].cornerRadius
                  : cornerRadius
              }
              min={0}
              max={10}
              step={0.01}
              onChange={handleChange}
              valueLabelDisplay="auto"
              aria-labelledby="roundness-slider"
            />
          </div>
        )}
        {activeObj?.[0].class !== "circle" && (
          <FormControl>
            <Typography>Radius Is Factoral:</Typography>
            <RadioGroup
              aria-label="angle-type"
              name="angle-type"
              value={factoral}
              onChange={(e) => {
                canvas.renderAll();
                setFactoral(e.target.value);
              }}
            >
              <FormControlLabel
                value={true}
                label="Yes"
                control={<Radio checked={factoral} />}
              />
              <FormControlLabel
                value={false}
                label="No"
                control={<Radio checked={!factoral} />}
              />
            </RadioGroup>
          </FormControl>
        )}
        <>
          <Typography>Line Type:</Typography>
          <FormControl sx={{ width: "100%" }}>
            <Select value={lineStyle}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 100, // Limit the height
                  overflowY: "auto", // Enable vertical scrolling
                },
              },
            }} onChange={handleChangeLine}>
              <MenuItem value="solid">Solid</MenuItem>
              <MenuItem value="dotted">Dotted</MenuItem>
              <MenuItem value="dashed">Dashed</MenuItem>
              <MenuItem value="dashed-dotted">Dashed-Dotted</MenuItem>
            </Select>
          </FormControl>
        </>
      </>
    );
  }
  const handleColorTabChange = (event, newValue) => {
    setActiveColorTab(newValue);
    setColorTab(newValue === 0 ? "Fill" : newValue === 1 ? "Stroke" : "Opacity");
    //console.log("handleColorTabChange:", newValue);
  };
  
  //console.log("prevColor",prevColor)
  function tab2() {
    const allyColorProps = (index) => {
      return {
        id: `tab-1-${index}`,
        "aria-controls": `tabColor-${index}`,
      };
    };
    return (
      <>
        <Typography align="center" variant="h6">
          {colorTab}
        </Typography>
        <Tabs
          variant="fullWidth"
          value={activeColorTab}
          onChange={handleColorTabChange}
        >
          <Tooltip arrow title="Fill">
            <Tab
              label={<CgColorBucket size={22} />}
              {...allyColorProps(activeTab)}
            />
          </Tooltip>
          <Tooltip arrow title="Stroke">
            <Tab label={<ColorLensOutlined />} {...allyColorProps(activeTab)} />
          </Tooltip>
          <Tooltip arrow title="Opacity">
            <Tab label={<GradientOutlined />} {...allyColorProps(activeTab)} />
          </Tooltip>
        </Tabs>
        <TabPanel
          subClass={"tab-1"}
          type={"tabColor"}
          value={activeColorTab}
          index={0}
        >
         <div style={{ display: 'flex', width:"90%",padding:"10px", alignItems: 'center', justifyContent: 'space-around' }}>
                    <StyledSubMenu>
                      Previous Colour
                      <div style={{
                        width: '100px',
                        height: '30px',
                        border: '1px solid black',
                        background: prevColor.field === "fill" ? prevColor.color : undefined,
                        backgroundColor: prevColor.field === "fill" ? prevColor.color : undefined,
                        marginTop: '5px'
                      }} />
                    </StyledSubMenu>

                    <StyledSubMenu>
                      Current Colour
                      <div style={{
                        width: '100px',
                        height: '30px',
                        border: '1px solid black',
                        background: fillValue ? fillValue : undefined,
                        backgroundColor: !fillValue ? fillValue : undefined,
                        marginTop: '5px'
                      }} />
                    </StyledSubMenu>
                  </div>
          <ColorWheel
            color={fillValue}
            value={fillValue}
            width={280}
            // hideControls hideGradientControls hideInputs hidePresets
            onChange={(newColor) =>{
              //console.log("fillValue",fillValue)
                
               if(fillValue !==undefined)
                {
                  setPrevColor((prev) => ({
                  field: "fill",
                  color:fillValue == "#F53922" ? "transparent": fillValue // Store the last used color
                }));
              }
                handlePositionChange("fill", newColor)
              } } // Handle background color change
          /> 
        </TabPanel>
        <TabPanel
          subClass={"tab-1"}
          type={"tabColor"}
          value={activeColorTab}
          index={1}
        >
          <div style={{ display: 'flex', width:"90%",padding:"10px", alignItems: 'center', justifyContent: 'space-around' }}>
                    <StyledSubMenu>
                      Previous Colour
                      <div style={{
                        width: '100px',
                        height: '30px',
                        border: '1px solid black',
                        background: strokePrevColor ? strokePrevColor : undefined,
                        backgroundColor: strokePrevColor ? strokePrevColor : undefined,
                        marginTop: '5px'
                      }} />
                    </StyledSubMenu>

                    <StyledSubMenu>
                      Current Colour
                      <div style={{
                        width: '100px',
                        height: '30px',
                        border: '1px solid black',
                        background: strokeValue ? strokeValue : undefined,
                        backgroundColor: !strokeValue ? strokeValue : undefined,
                        marginTop: '5px'
                      }} />
                    </StyledSubMenu>
                  </div>
          <ColorWheel
            color={strokeValue}
            value={strokeValue}
            width={280}
            // hideControls hideGradientControls hideInputs hidePresets
            onChange={(newColor) =>{

              setStrokePrevColor(strokeValue || "transparent" )
            handlePositionChange("stroke", newColor)}} // Handle background color change
          />
      
        </TabPanel>
        <TabPanel
          subClass={"tab-1"}
          type={"tabColor"}
          value={activeColorTab}
          index={2}
        > <label style={{fontSize:"15px"}}>Please Select a shape to change its opacity.</label>
                <div style={{  marginLeft:"20px",display:"flex", color:"white",}}>
               

                <Slider
                  sx={{
                    marginTop: '10px',
                    maxWidth: '220px',
                    '& .MuiSlider-mark': {
                      backgroundColor: 'blue',
                      height: '8px',
                      width: '2px',
                      '&.MuiSlider-markActive': {
                        opacity: 1,
                        backgroundColor: 'navyblue',
                      },
                    },
                    '& .MuiSlider-markLabel': {
                      color: 'white',
                    },
                  }}
                  value={opacityObj}
                  onChange={(e, newValue) => changeOpacityOfObj(newValue)}
                  step={0.01}
                  min={0}
                  max={1}
                  valueLabelDisplay="auto"
                  marks={marks}
                />
                </div>
              </TabPanel>
      </>
    );
  }

  function tab3() {
     if (!activeObj?.[0]) return null;
    return (
      <>
        {activeObj?.[0].class !== "line" && (
          <>
            <TextField
              label="SkewX"
              type="number"
              value={activeObj?.[0].skewX}
              onChange={(e) =>
                handlePropertyChange("skewX", parseFloat(e.target.value))
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="SkewY"
              type="number"
              value={activeObj?.[0].skewY}
              onChange={(e) =>
                handlePropertyChange("skewY", parseFloat(e.target.value))
              }
              fullWidth
              margin="normal"
            />
          </>
        )}
        {activeObj?.[0].class !== "circle" &&
          activeObj?.[0].class !== "line" && (
            <TextField
              label="Rotation (In Degree)"
              type="number"
              value={activeObj?.[0].angle}
              onChange={(e) =>
                handlePropertyChange("angle", parseFloat(e.target.value))
              }
              fullWidth
              margin="normal"
            />
          )}
        <TextField
          label="X-Axis"
          type="number"
          value={activeObj[0].left}
          onChange={(e) =>
            handlePositionChange("left", parseFloat(e.target.value))
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Y-Axis"
          type="number"
          value={activeObj[0].top}
          onChange={(e) =>
            handlePositionChange("top", parseFloat(e.target.value))
          }
          fullWidth
          margin="normal"
        />
      </>
    );
  }

  function tab4() {
    return <Typography align="center">Please Select a Shape</Typography>;
  }

  function tab5() {
    // List of crop shapes
    const cropShapes = [
      { id: 'rect', icon: <CropSquare />, label: 'Rectangle' },
      { id: 'rounded-rect', icon: <TbRectangle />, label: 'Rounded Rectangle' },
      { id: 'square', icon: <Stop />, label: 'Square' }, // or FaRegSquare
      { id: 'circle', icon: <CircleOutlined />, label: 'Circle' },
      { id: 'oval', icon: <TbOvalVertical />, label: 'Oval' },
      { id: 'triangle', icon: <ChangeHistory />, label: 'Triangle' },
      { id: 'diamond', icon: <TbDiamond />, label: 'Diamond' },
      { id: 'pentagon', icon: <BsPentagon />, label: 'Pentagon' },
      { id: 'hexagon', icon: <BsHexagon />, label: 'Hexagon' },
      { id: 'octagon', icon: <BsOctagon />, label: 'Octagon' },
      { id: 'star', icon: <StarBorder />, label: 'Star' },
      { id: 'leaf', icon: <BsBoundingBoxCircles />, label: 'Rounded Diagonal' },
    ];

    const handleSelectCropShape = (shapeId) => {
      setSelectedCropShape(shapeId);
      handleCropShapeChange(shapeId);
    };

    return (
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h6" align="center">
          Crop Tool
        </Typography>
        <Typography variant="body2" align="center" color="textSecondary">
          Select a shape to crop.
        </Typography>

        <Divider />

        <Typography variant="subtitle2" gutterBottom align="center">
          Crop Shape
        </Typography>
        
        {/* Shape Grid */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', mb: 2 }}>
            {cropShapes.map((shape) => {
              const isSelected = selectedCropShape === shape.id;
              return (
                <Tooltip title={shape.label} key={shape.id} arrow>
                    <Button 
                        variant={isSelected ? "contained" : "outlined"}
                        sx={{ 
                            minWidth: '40px', 
                            width: '40px', 
                            height: '40px', 
                            p: 0,
                            color: isSelected ? '#fff' : '#555',
                            backgroundColor: isSelected ? '#1976d2' : 'transparent',
                            borderColor: isSelected ? '#1976d2' : '#ddd',
                            border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
                            boxShadow: isSelected ? '0 0 8px rgba(25, 118, 210, 0.6)' : 'none',
                            transform: isSelected ? 'scale(1.1)' : 'scale(1)',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              backgroundColor: isSelected ? '#1565c0' : 'rgba(0,0,0,0.04)',
                              transform: isSelected ? 'scale(1.15)' : 'scale(1.05)',
                              boxShadow: isSelected ? '0 0 12px rgba(25, 118, 210, 0.8)' : 'none',
                            }
                        }}
                        onClick={() => handleSelectCropShape(shape.id)}
                    >
                        {shape.icon || <CropSquare />} {/* Fallback icon */}
                    </Button>
                </Tooltip>
              );
            })}
        </Box>

        <Divider />
        
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
             handleApplyCrop(); 
             setSelectedCropShape('rect');
             setActiveTab(1);
          }}
          startIcon={<Crop />}
        >
          Apply Crop
        </Button>
        <Button variant="outlined" color="error" onClick={() => {
           handleCancelCrop();
           setSelectedCropShape('rect');
           setActiveTab(1); 
        }}>
          Cancel
        </Button>
      </Box>
    );
  }
  useEffect(() => {
    if (
      (activeObj?.[0]?.class === "chart" || activeObj?.[0]?.class === "plot") &&
      (activeTab === 1 || activeTab === 2)
    ) {
      setActiveTab(0);
    }
    //console.log("handleTabChange: newValue: ", activeTab);
  }, [activeObj?.[0]?.class]);

  const strokeValue =
    typeof activeObj?.[0]?.stroke === "object"
      ? gradientToCssString(activeObj?.[0]?.stroke)
      : activeObj?.[0]?.stroke === "black"? "black" : activeObj?.[0]?.stroke 
  const fillValue =
    typeof activeObj?.[0]?.fill === "object"
      ? gradientToCssString(activeObj?.[0]?.fill)
      : activeObj?.[0]?.fill === "transparent" ? "#F53922" :activeObj?.[0]?.fill  ;

      //console.log("fillValue",fillValue)

      useEffect(()=>{
        //console.log("activeObj",activeObj)
        if(activeObj?.[0]?.fill === "transparent"){
            setPrevColor((prev) => ({
            field: "fill",
            color:activeObj?.[0]?.fill === "transparent" && "transparent"// Store the last used color
          }));
        } 
        else if(activeObj?.[0]?.stroke === "black"){
          setStrokePrevColor(activeObj?.[0]?.stroke === "black" ? "transparent":null)
        } 
      },[activeObj])
      //console.log("StrokePrevColor",strokePrevColor)
  return (
    <ShapeEditorDrawer
      open={open}
      // onClose={handleClose}
      variant="permanent"
      anchor="right"
      sx={{
        "& .MuiDrawer-paper": {
          ...(!open && {
            // width: `calc(${theme.spacing(7)} + 1px)`, // Keep tabs visible when closed
            marginTop: `${containerDim.marginTop + 0.45}px`,
            overflow: "hidden",
          }),
          ...(open && {
            width: drawerWidth + 160, // Full width when open
            marginTop: `${containerDim.marginTop + 0.45}px`,
            overflow: "auto",
          }),
        },
      }}
    >
      <div style={{ display: "flex" }}>
        <Tabs
          sx={{
            p: 0,
            justifyContent: "center",
            ...(open ? {} : { alignItems: "center" }),
          }}
          orientation="vertical"
          value={activeTab}
          onChange={handleTabChange}
          aria-label="edit panel tabs"
        >
          {tabs.map((tab, index) => (
            <Tooltip placement="left" key={index} arrow title={tab.title}>
              <Tab
                sx={{
                  ml: 0,
                  p: 0,
                  mt: 4,
                  minWidth: 50,
                }}
                hidden={index === 6 ? true : false}
                label={tab.icon}
                disabled={tab?.disabled}
                {...a11yProps(index)}
              />
            </Tooltip>
          ))}
        </Tabs>

        {open && (
          <TabPanel
            subClass={"tab"}
            type={"tabpanel"}
            value={activeTab}
            index={activeTab}
            sx={{ flexGrow: 1 }}
          >
            <div
              style={{
                display: "flex",
                padding: "0px 10px",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <TextField
                label="Unit"
                type="number"
                value={activeObj?.[0].unit || "px"}
                onChange={(e) => handlePropertyChange("unit", e.target.value)}
                select
                margin="normal"
              >
                <MenuItem value="px">Pixels (px)</MenuItem>
                <MenuItem value="cm">Centimeters (cm)</MenuItem>
                <MenuItem value="mm">Millimeters (mm)</MenuItem>
                <MenuItem value="in">Inches (in)</MenuItem>
                <MenuItem value="feet">Feet (feet)</MenuItem>
              </TextField>
              <Tooltip
                arrow
                title={
                  activeObj?.length === 1 ? "Delete Object" : "Delete Objects"
                }
              > 
                <Button
                  variant="outlined"
                  sx={{
                    height: 50,
                    width: 50,
                    background: "#f53b22c6",
                    "&:hover": { background: "#F53922" },
                  }}
                  onClick={handleDeleteObject}
                >
                  <Delete />
                </Button>
              </Tooltip>
              <Tooltip arrow title={"Skew Controls"}>
                <Button
                  variant="outlined"
                  sx={{
                    height: 50,
                    width: 50,
                    background: "#547384ff",
                    "&:hover": { background: "#7babc7" },
                  }}
                  onClick={addCustomControls}
                >
                  <TbSkewX size={22} />
                </Button>
              </Tooltip>
            </div>
            <Divider />
            <div
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                display: "flex",
                height: "calc(100vh - 250px)",
              }}
            >
              {activeTab === 1 && tab0()}
              {activeTab === 2 && tab1()}
              {activeTab === 3 && tab2()}
              {activeTab === 4 && tab3()}
              {/* {!activeObj && activeTab === 5 && tab4()} */}
              {activeTab === 5 && tab5()}
            </div>
          </TabPanel>
        )}
      </div>
    </ShapeEditorDrawer>
  );
};
